export function ensureArray(ar) {
    return Array.isArray(ar) ? ar : [ar].filter((f) => f !== undefined)
}
